export enum RateAgreementQuestionType {
    FURTHER_QUESTIONS = "FURTHER_QUESTIONS",
    EDIT_EXISTING_RATE_AGREEMENT = "EDIT_EXISTING_RATE_AGREEMENT",
}
